/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TBrandCreateRequest } from "../../redux-modules/declarations/maps/brand";
import apiClient from "../../utils/apiClient";

export const apiBrandCreate = (
  data: TBrandCreateRequest,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .post(API_ENDPOINTS.BRAND, data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
